import { defineStore } from 'pinia';
import type { State, dialogPanelKey } from './types';

export const usePanelActionStore = defineStore('PanelAction', {
	state: (): State => ({
		dialog: {
			quote: false,
			event: false,
			feedback: false,
		},
	}),

	actions: {
		showSpecialDialog(specialDialog: dialogPanelKey) {
			Object.keys(this.dialog).forEach((key) => {
				// @ts-ignore
				this.dialog[key] = false;
			});

			this.dialog[specialDialog] = true;
		},

		handlePrint() {
			if (window !== undefined) {
				window.print();
			}
		},
	},
});
